import { API_BASE_API_SSO_URL } from '../urls';

export const API_USERS_SETTINGS_SET_NOTIFICATIONS = `${API_BASE_API_SSO_URL}/users/settings/update`;
export const API_USERS_DELETE_REQUEST = `${API_BASE_API_SSO_URL}/users/delete/request`;
export const API_USERS_DELETE_CONFIRM = `${API_BASE_API_SSO_URL}/users/delete/confirm`;
export const API_USERS_DISTRIBUTION_LIST = `${API_BASE_API_SSO_URL}/users/distribution_list`;
